import React, { useRef, useState, useCallback } from 'react'
import List from '../../../grid.component';
import { useParams } from 'react-router-dom';
import { DateColumnHandler, NumberFormatter, StatusColumnHandler, TransactionsIdColumnHandler } from '../../service';
import { badge } from 'src/utils/statusColorsCode';

const renderNumberColumn = (key) => (cellProps) => {
  const value = cellProps?.dataItem?.[key] || "0";
  return <NumberFormatter value={value} />;
};

const CustomerTransactionsGrid = ((props) => {
  const gridRef = useRef(null);
  const { id } = useParams();
  const [copiedId, setCopiedId] = useState('');

  const handleIdCopy = useCallback((id) => {
    setCopiedId(id);
    setTimeout(() => {
      setCopiedId('');
    }, 300)
  }, [])

  const dateColumnHandler = (props) => { return (<DateColumnHandler data={props} />) }
  const statusColumnHandler = (props) => { return (<StatusColumnHandler data={props} badge={badge} />) }
  const idColumnHandler = (props) => { return (<TransactionsIdColumnHandler data={props} copiedId={copiedId} handleIdCopy={handleIdCopy} />) }

  const renderCustomCell = useCallback((transcationProps, column) => {
    const customCells = {
      "transactionId": idColumnHandler,
      "state": statusColumnHandler,
      "applyTime": dateColumnHandler,
      "amount": renderNumberColumn("amount"),
      "fee": renderNumberColumn("fee"),
      "walletBefore": renderNumberColumn("walletBefore"),
      "walletAfter": renderNumberColumn("walletAfter"),
      "beforeAmount": renderNumberColumn("beforeAmount"),
      "afterAmount": renderNumberColumn("afterAmount"),
    }
    if (customCells[column.field])
      return customCells[column.field](transcationProps);
  }, [copiedId])
  return (
    <div>
      <List
        url={process.env.REACT_APP_GRID_API + `api/KycService/CustomerCardTransactions/${id}`}
        additionalParams={props?.filterValues}
        pSize={10}
        className="custom-grid"
        ref={gridRef}
        showExcelExport={props?.isExcelExport}
        pKey={"Transactions"}
        screenName={'Customer_Transactions'}
        renderCustomCell={renderCustomCell}
        showDisplayColumns={false}
      />
    </div>
  )
})
export default React.memo(CustomerTransactionsGrid)
